// v-no-autofill: verhindert automatisches Befüllen durch Browser/Passwort-Manager.
// - readonly bis zum ersten Fokus: Autofill beim Seitenladen prallt ab
// - zufälliger name pro Mount: bricht gelernte Feld-Signaturen der Extensions
// - autocomplete="off" als Basissignal
// Modifier .focus: Feld nach dem Mount fokussieren (hebt readonly direkt wieder auf).
export default {
  mounted(el, binding) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
    if (!input) return;

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('name', `nf-${Math.random().toString(36).slice(2, 10)}`);

    input.readOnly = true;
    input.addEventListener('focus', () => {
      input.readOnly = false;
    });
    input.addEventListener('blur', () => {
      if (!input.value) input.readOnly = true;
    });

    if (binding?.modifiers?.focus) {
      requestAnimationFrame(() => input.focus());
    }
  },
};
